import { z } from 'zod'

import { AcademySchema } from '~/@entities/Academy'
import { ServiceTypeSchema } from '~/@entities/Student'

/***************** 선생님 권한 *****************/
// 관리자(ROOT)·전체 학생 관리(MANAGER)·담당 학생만 관리(HOMEROOM)
export const TEACHER_TYPE = ['ROOT_TEACHER', 'MANAGER_TEACHER', 'HOMEROOM_TEACHER'] as const

// 선생님 고유 ID(`T3244`). 서버가 PK 앞에 T 를 붙여 만든다(TeacherEntity).
export const TeacherIdSchema = z.string().regex(/^T/, '선생님 ID 는 T 로 시작한다')
export type TeacherId = z.infer<typeof TeacherIdSchema>

export const TeacherTypeSchema = z.enum(TEACHER_TYPE)
export type TeacherType = z.infer<typeof TeacherTypeSchema>

// /teachers 목록과 /teachers/{id} 의 한 명. phone 은 서버가 null 을 빈 문자열로 바꿔 싣는다(TeacherResponse.of).
// 2026-10-14 백엔드 develop(6a0f8e7bb) 의 teacher/controller/response/TeacherResponse.kt 와 팀이 녹음한 dev 응답
// e2e 목(teacher-by-id.json)으로 확인.
export const TeacherSchema = z.object({
  teacherId: TeacherIdSchema,
  academyId: AcademySchema.shape.academyId,
  loginId: z.string(),
  name: z.string(),
  phone: z.string(),
  type: TeacherTypeSchema,
  /** false 면 일시 비활성 선생님이다 */
  present: z.boolean(),
  allowedServiceTypes: z.array(ServiceTypeSchema),
})
export type Teacher = z.infer<typeof TeacherSchema>

/** 기간 안에 로그인한 선생님이 만든 학습지 수와 올린 기출 원본 수 */
export const TeacherActivityCountSchema = z.object({
  worksheetCount: z.number(),
  paperUploadCount: z.number(),
})
export type TeacherActivityCount = z.infer<typeof TeacherActivityCountSchema>

/** 로그인한 선생님 학원의 선생님 한 명. 나의DB 의 올린 선생님 필터가 쓴다 */
export const TeacherInAcademySchema = TeacherSchema.pick({ teacherId: true, name: true }).extend({
  /** false 면 일시 비활성 선생님이다 */
  isPresent: TeacherSchema.shape.present,
  isMe: z.boolean(),
})
export type TeacherInAcademy = z.infer<typeof TeacherInAcademySchema>
